module.exports = __webpack_public_path__ + "static/media/botao-medico_especialista.4c8634b7.png";